import { LinkProps as MUILinkProps, Link as MUILink } from "@mui/material";
import { FC } from "react";

import {Link as RouterLink, LinkProps as RouterLinkProps} from "react-router-dom";

interface Props extends MUILinkProps, RouterLinkProps  {
    color?: string;
    native?: boolean;
}

const Link: FC<Props> = ({children, ...props}) => {
    const Component = props.native ? 'a' : RouterLink;

    return <MUILink component={Component} {...props}>
        {children}
    </MUILink>;
};

export default Link;